import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Client } from 'models/ClientModel';


const ClientList: React.FC = () => {
  const width = { sno: 10, name: 20, address: 25, dob: 10, phone: 15, email: 15 };
  const [formId, formName] = [Code.Form.Id.CLIENT, Code.Form.Name.CLIENT];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [clientData, setClientData] = useState<Client[]>([]); 
  const [selectedClient, setselectedClient] = useState<Client | null>(null);
  const triggers = [pno, pageRows, search, activeId];
  const Privilege = Hooks.Privilege.List(formId);
  //console.log("Privilege---->",Privilege);
  Hooks.Privilege.HasView(Privilege);
  const locationId = Utility.Storage.LocationId();
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
    
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Client.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Client.Id, 
        Name.Client.Number, 
        Name.Client.FullName, 
        Name.Client.Address, 
        Name.Client.Dob, 
        Name.Client.Phone, 
        Name.Client.Email
      ]),
      ...(!Privilege.ALLLOC && { location_id: locationId })
    });
     
    await API.Data.List<Client>(url, setClientData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={"patient"} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.State} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, clientData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                ["#ID", width.sno],
                [Title.Client, width.name],
                [Title.Address, width.address], 
                [Title.DOB, width.dob], 
                [Title.Phone, width.phone], 
                [Title.Email, width.email]
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(clientData) && (
              <Control.Grid.Row>
                {clientData.map((clientData) => { const path = Utility.Join.Edit(Privilege, formName, clientData.client_key); return (
                <Control.Grid.Data<Client> key={clientData.client_id} itemKey={clientData.client_key} data={clientData} setMenuPosition={setMenuPosition} setSelectedData={setselectedClient} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={clientData.client_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={path} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Text value={`#${clientData.client_number}`} width={width.sno} />
                  <Control.Grid.Link path={path} width={width.name} iframeRef={iframeRef} value={Utility.Get.FullName(clientData,Code.Form.Name.CLIENT)} />
                  <Control.Grid.Items values={[
                    [clientData.client_address, width.address], 
                    [Utility.Format.DateOnly(clientData.client_dob,true), width.dob], 
                    [Utility.Format.Phone(clientData.client_phone,true), width.phone], 
                    [clientData.client_email, width.email]
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={clientData.client_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={clientData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedClient?.client_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedClient?.client_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default ClientList;